var debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


var forEach = function(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

var toggleClass = function(target, className) {
  return target.classList.toggle(className);
}

var removeClass = function(targets, className) {
	forEach(targets, (i, target) => target.classList.remove(className));
}

// Prevents tabbing to items in the query.
var disableLinkTabbing = function(query){
  var links = query.querySelectorAll('a');
  [].forEach.call(links, function (link) {
    link.setAttribute("tabindex", "-1");
  })
};

// Re-enables tabbing to items in the query.
var enableLinkTabbing = function(query){
  var links = query.querySelectorAll('a');
    [].forEach.call(links, function (link) {
      link.setAttribute("tabindex", "0")
  })
};

var makeAjaxRequest = function(method, url, xhr) {
  return new Promise(function (resolve, reject) {
    xhr.open(method, url, true);
    xhr.responseType = 'json';
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
    }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
    });
    };
    xhr.send();
});
}


export { debounce, forEach, toggleClass, removeClass, disableLinkTabbing, enableLinkTabbing, makeAjaxRequest }
